import { requestClientTool } from "@src/store/slices/experienceBuilder/common/thunks/requestClientTool";

import { matchClientTool } from "../detect";
import { Continuation, Matcher } from "../types";

/**
 * `visual_builder_locate` — a client-produced-result tool. The server parks the
 * open call; this runs the locate (`document.querySelectorAll` against the live
 * iframe) via the generic client-tool channel and answers with a `tool-result`.
 * Read-only (no page effect), so the resolve thunk just runs and returns the
 * matched candidates as JSON text in a `content` block — the same content-block
 * envelope `visual_builder_evaluate_js` uses. The per-candidate data matches what
 * the removed headless locate tool produced; the envelope is now `content` text
 * rather than a `json` result.
 */
export const locate: Matcher = {
  match: (part) => {
    const call = matchClientTool(part, "visual_builder_locate");
    if (!call) {
      return null;
    }
    return async () => {
      try {
        const out = await requestClientTool(
          "visual_builder_locate",
          call.input
        );
        return {
          kind: "tool-result",
          toolCallId: call.toolCallId,
          output: {
            type: "content",
            value: [{ type: "text", text: JSON.stringify(out) }],
          },
        } satisfies Continuation;
      } catch (e) {
        // Answer the open call with an error so the model isn't left waiting.
        return {
          kind: "tool-result",
          toolCallId: call.toolCallId,
          output: {
            type: "content",
            value: [
              {
                type: "text",
                text: `Locate failed: ${
                  e instanceof Error ? e.message : String(e)
                }`,
              },
            ],
          },
        } satisfies Continuation;
      }
    };
  },
};
